import { Link } from "react-router-dom";
import { Instagram, Facebook, Youtube, Mail } from "lucide-react";
import { useContent, SITE_DEFAULTS } from "@/lib/content";

const SOCIAL = [
  { test: /instagram\.com/i, Icon: Instagram },
  { test: /facebook\.com|fb\.com/i, Icon: Facebook },
  { test: /youtube\.com|youtu\.be/i, Icon: Youtube },
  { test: /^mailto:/i, Icon: Mail },
];
const iconFor = (url) => SOCIAL.find((s) => s.test.test(url))?.Icon;

export const SiteFooter = () => {
  const site = useContent("site", SITE_DEFAULTS);
  const links = [1, 2, 3, 4, 5, 6]
    .map((i) => ({ label: site[`footer_link${i}_label`], url: site[`footer_link${i}_url`], i }))
    .filter((l) => l.label && l.url);
  const text = links.filter((l) => !iconFor(l.url));
  const icons = links.filter((l) => iconFor(l.url));
  const cls = "font-semibold text-slate-500 dark:text-slate-400 transition-colors hover:text-rose-600";
  return (
    <footer className="border-t border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 py-8">
      <div className="mx-auto flex max-w-7xl flex-col gap-4 px-4 text-sm text-slate-400 dark:text-slate-500 sm:flex-row sm:items-center sm:justify-between sm:px-6">
        <span data-testid="site-footer">© {new Date().getFullYear()} {site.footer_text}</span>
        {links.length > 0 && (
          <nav className="flex flex-wrap items-center gap-x-5 gap-y-3" data-testid="footer-links">
            {text.map((l) => l.url.startsWith("/") ? (
              <Link key={l.i} to={l.url} data-testid={`footer-link-${l.i}`} className={cls}>{l.label}</Link>
            ) : (
              <a key={l.i} href={l.url} target={l.url.startsWith("http") ? "_blank" : undefined} rel="noreferrer" data-testid={`footer-link-${l.i}`} className={cls}>{l.label}</a>
            ))}
            {icons.length > 0 && (
              <span className="flex items-center gap-2">
                {icons.map((l) => { const Icon = iconFor(l.url); return (
                  <a key={l.i} href={l.url} target={l.url.startsWith("http") ? "_blank" : undefined} rel="noreferrer" aria-label={l.label} title={l.label}
                    data-testid={`footer-link-${l.i}`}
                    className="flex h-9 w-9 items-center justify-center rounded-full border border-slate-200 dark:border-slate-700 text-slate-500 dark:text-slate-400 transition-all hover:-translate-y-0.5 hover:border-rose-500 hover:bg-rose-600 hover:text-white">
                    <Icon className="h-4 w-4" strokeWidth={2} />
                  </a>
                ); })}
              </span>
            )}
          </nav>
        )}
      </div>
    </footer>
  );
};
